import _classCallCheck from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { useMemo } from 'react';
import { ENDPOINTS } from '../../endpoints';
import { Service } from '../base';
import dynamicAxios from '../../utils/axios';
import useServices from '../../hooks/useServices';

var ServiceCvParsing = /*#__PURE__*/function (_Service) {
  _inherits(ServiceCvParsing, _Service);

  var _super = _createSuper(ServiceCvParsing);

  function ServiceCvParsing() {
    _classCallCheck(this, ServiceCvParsing);

    return _super.apply(this, arguments);
  }

  _createClass(ServiceCvParsing, [{
    key: "getUnanalysedParsedCv",
    value: function getUnanalysedParsedCv() {
      return this.axiosInstance.get(ENDPOINTS.cvParsing.unanalysedParsedCv);
    }
  }, {
    key: "collectErrors",
    value: function collectErrors(params) {
      return this.axiosInstance.post(ENDPOINTS.cvParsing.collectErrors, params);
    }
  }, {
    key: "setParsedCvAsAnalysed",
    value: function setParsedCvAsAnalysed(cvUrl) {
      return this.axiosInstance.get(ENDPOINTS.cvParsing.setCvAsAnalysed, {
        params: {
          cv_url: cvUrl
        }
      });
    }
  }, {
    key: "getCorrectedCvCount",
    value: function getCorrectedCvCount() {
      return this.axiosInstance.get(ENDPOINTS.cvParsing.correctedCvCount);
    }
  }]);

  return ServiceCvParsing;
}(Service);

export function useCvParsingService() {
  var _useServices = useServices(),
      baseUrl = _useServices.baseUrl,
      jwt = _useServices.jwt;

  return useMemo(function () {
    return new ServiceCvParsing(dynamicAxios(baseUrl, jwt));
  }, [baseUrl, jwt]);
}
export default useCvParsingService;
export * from './types';